import { queryOptions, useQuery } from '@tanstack/react-query';
import { LoopPlannerTimelineItemsApi } from '@/features/planner/api/timelineItems';
import { plannerQueryKeys } from '@/features/planner/queryKeys';

export const bulkFetchTimelineItemsQueryOptions = ({
  loopId,
  scenarioId,
  itemIds,
  enabled = true,
  staleTime,
}: {
  loopId: number;
  scenarioId: number;
  itemIds: number[];
  enabled?: boolean;
  staleTime?: number;
}) =>
  queryOptions({
    queryKey: plannerQueryKeys.timelineItems.bulkFetch({ loopId, scenarioId, itemIds }),
    queryFn: () => LoopPlannerTimelineItemsApi.bulkFetch({ loopId, scenarioId, itemIds }),
    enabled: enabled && itemIds.length > 0,
    ...(staleTime !== undefined && { staleTime }),
  });

export const useBulkFetchTimelineItems = ({
  loopId,
  scenarioId,
  itemIds,
  enabled,
  staleTime,
}: {
  loopId: number;
  scenarioId: number;
  itemIds: number[];
  enabled?: boolean;
  staleTime?: number;
}) => {
  return useQuery(
    bulkFetchTimelineItemsQueryOptions({ loopId, scenarioId, itemIds, enabled, staleTime }),
  );
};
